import Controller from "./Controller.ts";
import {
  KLARITICS_LAST_BG_TIME_KEY,
  KLARITICS_SESSION_ID,
  FOREGROUND,
  SYSTEM_EVENT
} from "./constants.ts";
import { isDefined, millisToSeconds } from "./utils.ts";
import type { SystemEvent } from "./types/types.ts";

export default class SessionHandler {
  private _lastBackgroundTime = -1;
  private _totalBackgroundTime: number;

  constructor(totalBgTime = 0) {
    Controller.getInstance().registerForEvent(
      SYSTEM_EVENT,
      this._onSystemEvent
    );
    this._totalBackgroundTime = totalBgTime;
    Controller.getInstance().persistToStorage(
      KLARITICS_LAST_BG_TIME_KEY,
      String(this._lastBackgroundTime)
    );
  }

  getTotalBackgroundTime = (): number => this._totalBackgroundTime;

  getLastBackgroundTime = (): number => this._lastBackgroundTime;

  reset = (): void => {
    this._lastBackgroundTime = -1;
    this._totalBackgroundTime = 0;
  };

  private _onSystemEvent = (event: unknown): void => {
    const e = event as SystemEvent;
    const eventName = e.name;

    if (eventName === FOREGROUND) {
      if (this._lastBackgroundTime !== -1) {
        const time = Math.round(
          millisToSeconds(Date.now() - this._lastBackgroundTime)
        );
        this._totalBackgroundTime += time;

        const sessionId = Controller.getInstance().getFromStorage(
          KLARITICS_SESSION_ID
        ) as string;
        if (
          isDefined(sessionId) &&
          Controller.getInstance().getSessionId() !== sessionId
        ) {
          Controller.getInstance().createANewChunk();
          const { total_duration, duration } =
            Controller.getInstance().getSessionInfo();
          if (isDefined(total_duration) && isDefined(duration))
            this._totalBackgroundTime =
              total_duration > duration ? total_duration - duration : 0;
        }
      }
    } else {
      this._lastBackgroundTime = Date.now();
      Controller.getInstance().persistToStorage(
        KLARITICS_LAST_BG_TIME_KEY,
        String(this._lastBackgroundTime)
      );
    }
  };
}
